import {
  Component,
  OnInit,
  OnChanges,
  SimpleChanges,
  Input,
} from '@angular/core';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-title-setter',
  templateUrl: './title-setter.component.html',
  styleUrls: ['./title-setter.component.scss'],
})
export class TitleSetterComponent implements OnChanges {
  @Input() title!: string;
  constructor(private titleService: Title) {}
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.title) {
      if (this.title) {
        const t = this.title.replace('null ', '');
        this.titleService.setTitle(t);
      }
    }
  }
}
